import React, { useEffect, useState } from "react";
import Weekend from "./Weekend";
import { Title } from "racing-renderings-library/src/Components/Title/Title";
import { getIcons, sendError } from "racing-renderings-library/src/utils";
import Preloader from "racing-renderings-library/src/Components/Preloader/Preloader";
import { getData } from "./dataPreparation";
import defLogo from "../../../assets/images/common/MotorsportLogo.png";
import { UnauthorizedPage } from "../UnauthorizedPage/UnauthorizedPage";
import { UNAUTHORIZED_EXCEPTION_MESSAGE } from "../../restAPI";

const IS_CONFIG = process.env.REACT_APP_IS_CONFIG;

const WeekendContainer = ({ id, color, theme }) => {
  const [icons, setIcons] = useState({ ready: false });
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(undefined);
  const [unauthorized, setUnauthorized] = useState(false);

  useEffect(() => {
    console.log("lib 1.0.0");
    getIcons().then((i) => {
      setIcons({ icons: i, ready: true });
    });
  }, []); // load icons

  useEffect(() => {
    setData(undefined);
    setError(undefined);
    if (icons.ready && id !== null) {
      getData(id, icons.icons)
        .then((d) => {
          if (d.error !== undefined) {
            setError(d.error);
            if (d.error === UNAUTHORIZED_EXCEPTION_MESSAGE) {
              setUnauthorized(true);
            }
          }
          if (d) setData({ ...d });
          else setError(true);
        })
        .catch((e) => {
          console.error(e);
          sendError(e);
          setError(true);
        });
    }
  }, [icons.ready, id]); // load data

  if (unauthorized) return <UnauthorizedPage />;
  if (id === null) {
    sendError({ name: "No event id" });
    return null;
  }
  if (error) return null;
  if (data === undefined) return <Preloader />;
  return (
    <div>
      <div style={{ margin: "15px" }}>
        <Title
          title={"FULL WEEKEND DRIVER POSITIONS"}
          name={data.title.name}
          date={data.title.date}
          color={theme !== undefined && theme.mainColor !== undefined ? theme.mainColor : color}
          logoSrc={theme !== undefined ? theme.logo : defLogo}
          font={theme?.font}
        />
      </div>
      <Weekend
        data={data}
        icons={icons.icons}
        color={color}
        logo={theme?.logo ?? defLogo}
        isConfig={IS_CONFIG}
        theme={theme}
      />
    </div>
  );
};

export default WeekendContainer;
